export const selectCompanyDetails = state => state.companies.companyDetails
export const selectCompaniesSearchResult = state => state.companies.searchResult
export const selectCompaniesWhitelist = state => state.companies.whitelist
export const selectCompaniesBlacklist = state => state.companies.blacklist
export const selectAllMarkedCompanies = state =>
  state.companies.allMarkedCompanies
export const selectCompaniesState = state => state.companies.state
export const selectCompaniesErrorMessage = state => state.companies.errorMessage
